// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__119AQ","textarea":"Input_textarea__kLQiU","label":"Input_label__2lxHn"};